import { Modal } from '@fl/cmsch-fe-library';
import React, { memo, FC } from 'react';
import { Opt } from 'ts-opt';
import { CriteriaList } from 'api/gen/CriteriaList';
import { useOurTranslation } from 'app/translations';
import { CreateCriteriaListForm } from './form';
interface Props {
  /** Whether the modal is visible. */
  visible: boolean;
  /** Saved criteria lists available to the user. */
  criteriaLists: Opt<Array<CriteriaList>>;
  /** Saved table-setting names used for collision checks. */
  tableSettingsNameList: Array<string>;
  /** Handles creation submission. */
  onSubmit(name: string): void;
  /** Handles cancel and close. */
  onCancel(): void;
}
const ModalCriteriaListNameBase: FC<Props> = props => {
  const {
    visible,
    criteriaLists,
    tableSettingsNameList,
    onSubmit,
    onCancel
  } = props;
  const {
    t
  } = useOurTranslation('mating');
  return <Modal title={t('enterCriteriaListName')} visible={visible} onCancel={onCancel} footer={null} data-sentry-element="Modal" data-sentry-component="ModalCriteriaListNameBase" data-sentry-source-file="index.tsx">
            <CreateCriteriaListForm criteriaLists={criteriaLists} tableSettingsNameList={tableSettingsNameList} onCancel={onCancel} onSubmit={onSubmit} visible={visible} data-sentry-element="CreateCriteriaListForm" data-sentry-source-file="index.tsx" />
        </Modal>;
};

/**
 * Memoized modal that asks for a new criteria list name.
 *
 * @param props Saved criteria lists and modal handlers.
 * @returns The criteria-list naming modal.
 *
 * @example
 * <ModalCriteriaListName
 *   visible={visible}
 *   criteriaLists={criteriaLists}
 *   tableSettingsNameList={[]}
 *   onSubmit={handleSubmit}
 *   onCancel={handleCancel}
 * />
 */
export const ModalCriteriaListName = memo(ModalCriteriaListNameBase);